module.exports = __webpack_public_path__ + "img/03_SPHERE-GAS.cc6db3e6.gif";